module.exports = __webpack_public_path__ + "static/img/wenhua7.93a9609.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenhua7.jpg
// module id = sSXs
// module chunks = 1